import { createApi } from "@reduxjs/toolkit/query/react";
import endpoints, { baseURL } from "data/api/v1/endpoints.ts";
import { baseQueryWithRedirect } from "features/api/utils/apiUtils.ts";
import { models } from "types/api/viewModels.ts";
import { countUnassignedOpenLeads } from "./dashboardCounts";
import { GetNewsArchiveRequest, GetNewsArchiveResponse, GetNewsArchiveResponseData } from "./getNewsArchive.ts";

interface ContextQuery {
	contextKey: string;
}

interface ApiResponse<T> {
	data?: T | null;
}

export const dashboardApiSlice = createApi({
	reducerPath: "dashboardApi",
	baseQuery: baseQueryWithRedirect(baseURL, false),
	tagTypes: ["ActionItems", "DashboardLeads"],
	endpoints: (builder) => ({
		getDashboardActionItemCount: builder.query<number, ContextQuery>({
			query: () => `${baseURL}/api/v1/orders/updates`,
			transformResponse: (response: ApiResponse<models["ImportantUpdateViewModel"][]>) =>
				response.data?.length ?? 0,
			providesTags: ["ActionItems"]
		}),
		getDashboardUnassignedLeadCount: builder.query<number, ContextQuery>({
			query: () => endpoints.leads.getLeads(),
			transformResponse: (response: ApiResponse<models["LeadAssignmentViewModel"][]>) =>
				countUnassignedOpenLeads(response.data ?? []),
			providesTags: ["DashboardLeads"]
		}),
		getNewsArchive: builder.query<GetNewsArchiveResponseData, GetNewsArchiveRequest>({
			query: (request) => ({
				url: endpoints.dashboard.getNewsArchive(),
				method: "POST",
				dataType: "json",
				headers: { "Content-type": "application/json; charset=UTF-8" },
				body: request
			}),
			transformResponse: (response: GetNewsArchiveResponse) => response?.data
		})
	})
});

export const { useGetDashboardActionItemCountQuery, useGetDashboardUnassignedLeadCountQuery, useGetNewsArchiveQuery } =
	dashboardApiSlice;

export const invalidateDashboardActionItems = () => dashboardApiSlice.util.invalidateTags(["ActionItems"]);
